import React from 'react';
import { Button, Text } from '@fluentui/react-components';
import { useMsal } from '@azure/msal-react';
import { useStyles } from './styles/AuthError.styles';
import { loginRequest } from '../auth/msalConfig';

interface AuthErrorProps {
  error?: string;
  onRetry?: () => void;
}

export const AuthError: React.FC<AuthErrorProps> = ({ 
  error = "Authentication failed. Please try again.", 
  onRetry 
}) => {
  const styles = useStyles();
  const { instance } = useMsal();

  const handleLogin = async () => {
    try {
      await instance.loginRedirect(loginRequest);
    } catch (err) {
      console.error('Login failed:', err);
      if (onRetry) {
        onRetry();
      }
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.errorCard}>
        <Text className={styles.title}>Authentication Required</Text>
        <Text className={styles.message}>{error}</Text>
        <Button 
          appearance="primary" 
          onClick={handleLogin}
          className={styles.loginButton}
        >
          Sign In
        </Button>
      </div>
    </div>
  );
};
